(function () {
  var PREORDER_URL = "https://getup-apparel-au.juno.page/getup-pre-order/";

  function firePixel(eventName, params) {
    try {
      if (typeof fbq !== "undefined") {
        if (params) {
          fbq("trackCustom", eventName, params);
        } else {
          fbq("trackCustom", eventName);
        }
      }
    } catch (e) {}
  }

  // Visiting the cart page directly -> pre-order page
  if (window.location.pathname === "/cart") {
    firePixel("PreOrderRedirect", { location: "cart" });
    window.location.href = PREORDER_URL;
    return;
  }

  function redirect(e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    firePixel("PreOrderClick");
    window.location.href = PREORDER_URL;
  }

  // Accelerated/dynamic checkout buttons are web components. Shadow-DOM
  // retargeting means e.target is often the host element, so match by tag name.
  var BUY_TAGS = {
    "shop-pay-wallet-button": 1,
    "shop-pay": 1,
    "shopify-accelerated-checkout": 1,
    "shopify-payment-button": 1,
    "apple-pay-button": 1,
    "gpay-button": 1,
    "google-pay-button": 1,
    "payment-button": 1
  };

  document.addEventListener("click", function (e) {
    var el = e.target;
    while (el && el !== document.documentElement) {
      var tag = (el.tagName || "").toLowerCase();

      if (BUY_TAGS[tag]) { redirect(e); return; }

      if (tag === "button" || tag === "input" || tag === "a") {
        var name = (el.getAttribute("name") || "").toLowerCase();
        var href = el.getAttribute("href") || "";
        var text = (el.textContent || "").toLowerCase().trim();
        var id = (el.getAttribute("id") || "").toLowerCase();
        var cls = (el.getAttribute("class") || "").toLowerCase();

        if (name === "add") { redirect(e); return; }

        if (
          name === "checkout" ||
          id === "checkout" ||
          text === "checkout" ||
          text === "buy with shop" ||
          text === "buy now" ||
          href.indexOf("/checkout") !== -1 ||
          /shopify-payment-button|payment-button|buy-with-shop/i.test(cls)
        ) { redirect(e); return; }

        if (el.closest("[data-shopify-payment-button], .shopify-payment-button, shop-pay-wallet-button, shopify-accelerated-checkout, apple-pay-button, gpay-button, google-pay-button")) {
          redirect(e); return;
        }
      }

      el = el.parentElement;
    }
  }, true);

  document.addEventListener("submit", function (e) {
    var action = (e.target && e.target.getAttribute && e.target.getAttribute("action")) || "";
    if (action.indexOf("/cart") !== -1) { redirect(e); return; }
  }, true);
})();
